import TextLink from './textLink'

export default TextLink
